import type { Session } from "@tellescope/sdk";

export const generateExplanation = async (
  session: Session,
  data: Array<Record<string, unknown>>,
  userQuery: string,
  visualizationType: string,
  orchestrationId: string
): Promise<string> => {
  try {
    const result = await session.api.ai_conversations.send_message({
      messages: [
        {
          role: "user" as const,
          text: `The user asked: "${userQuery}"

The data returned is: ${JSON.stringify(data)}

This will be displayed as a ${visualizationType}. Provide a brief (1-2 sentence) natural language summary highlighting key insights. Be concise and conversational. Don't include any JSON, code formatting, or technical details.`,
        },
      ],
      prompt: "You are a helpful data analyst assistant. Summarize data results briefly.",
      type: "summarization",
      orchestrationId,
      maxTokens: 200,
    });

    const responseMessages = result?.ai_conversation?.messages || [];
    const assistantMessage = responseMessages.find((m: { role: string }) => m.role === "assistant");
    return assistantMessage?.text || "";
  } catch {
    // If explanation generation fails, return empty string (visualization will still show)
    return "";
  }
};
